import axios from "axios";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../../button/back";

/* ================= MASTER DIMENSI ================= */
const MASTER_DIMENSI = [
  {
    no: 1,
    dimensi: "Keimanan dan Ketakwaan terhadap tuhan yang maha Esa",
    sub: "Hubungan dengan Tuhan Yang Maha Esa.",
  },
  {
    no: 2,
    dimensi: "Keimanan dan Ketakwaan terhadap tuhan yang maha Esa",
    sub: "Hubungan sesama manusia.",
  },
  {
    no: 3,
    dimensi: "Keimanan dan Ketakwaan terhadap tuhan yang maha Esa",
    sub: "Hubungan dengan Lingkungan Alam.",
  },
  { no: 4, dimensi: "Kewargaan", sub: "Kewargaan Lokal." },
  { no: 5, dimensi: "Kewargaan", sub: "Kewargaan Nasional." },
  { no: 6, dimensi: "Kewargaan", sub: "Kewargaan Global." },
  { no: 7, dimensi: "Penalaran Kritis", sub: "Penyampaian Argumentasi." },
  { no: 8, dimensi: "Penalaran Kritis", sub: "Pengambilan keputusan." },
  { no: 9, dimensi: "Penalaran Kritis", sub: "Penyelesaian Masalah." },
  { no: 10, dimensi: "Kreativitas", sub: "Gagasan Baru." },
  { no: 11, dimensi: "Kreativitas", sub: "Fleksibilitas berpikir." },
  { no: 12, dimensi: "Kreativitas", sub: "Karya." },
  { no: 13, dimensi: "Kemandirian", sub: "Bertanggung Jawab." },
  { no: 14, dimensi: "Kemandirian", sub: "Kepemimpinan." },
  { no: 15, dimensi: "Kemandirian", sub: "Pengembangan diri." },
  { no: 16, dimensi: "Kolaborasi", sub: "Peduli." },
  { no: 17, dimensi: "Kolaborasi", sub: "Berbagi." },
  { no: 18, dimensi: "Kolaborasi", sub: "Kerjasama." },
  { no: 19, dimensi: "Komunikasi", sub: "Menyimak." },
  { no: 20, dimensi: "Komunikasi", sub: "Membaca." },
  { no: 21, dimensi: "Komunikasi", sub: "Menulis." },
  { no: 22, dimensi: "Komunikasi", sub: "Berbicara." },
  { no: 23, dimensi: "Kesehatan", sub: "Hidup bersih dan sehat." },
  {
    no: 24,
    dimensi: "Kesehatan",
    sub: "Kebugaran, kesehatan fisik dan mental.",
  },
  { no: 25, dimensi: "Kesehatan", sub: "Kesehatan Lingkungan." },
];

const MAX_DIMENSI = 4;
const MAX_JUDUL = 2;

const EditKokulikuler = () => {
  const { id } = useParams();
  const [filter, setFilter] = useState({
    kelas: "",
    rombel: "",
    tahun: "",
    semester: "",
  });
  const [idData, setIdData] = useState(null);
  const [judulKokulikuler, setJudul] = useState([""]);
  const [pilihanDimensi, setPilihanDimensi] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= FILTER ================= */
  const handleFilterChange = (e) =>
    setFilter({ ...filter, [e.target.name]: e.target.value });

  /* ================= CARI DATA ================= */
  const handleCariData = async () => {
    const { kelas, rombel, tahun, semester } = filter;
    if (!kelas || !rombel || !tahun || !semester)
      return alert("Lengkapi semua filter");

    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/kokulikuler/${kelas}/${rombel}/${tahun}/${semester}`,
      );
      const data = Array.isArray(res.data) ? res.data[0] : res.data;

      setIdData(data._id);
      setJudul(data.judulKokulikuler || [""]);
      setPilihanDimensi(data.pilihanDimensi || []);
    } catch {
      alert("Data tidak ditemukan");
    } finally {
      setLoading(false);
    }
  };

  /* ================= JUDUL ================= */
  const handleJudulChange = (index, value) => {
    const updated = [...judulKokulikuler];
    updated[index] = value;
    setJudul(updated);
  };

  const addJudul = () => {
    if (judulKokulikuler.length >= MAX_JUDUL) return;
    setJudul([...judulKokulikuler, ""]);
  };

  const removeJudul = (index) => {
    if (judulKokulikuler.length === 1) return;
    setJudul(judulKokulikuler.filter((_, i) => i !== index));
  };

  /* ================= TOGGLE DIMENSI ================= */
  const toggleDimensi = (item) => {
    const exists = pilihanDimensi.some(
      (d) => d.DimensiProfile === item.dimensi && d.SubDimensi === item.sub,
    );

    if (exists) {
      setPilihanDimensi((prev) =>
        prev.filter(
          (d) =>
            !(d.DimensiProfile === item.dimensi && d.SubDimensi === item.sub),
        ),
      );
      return;
    }

    if (pilihanDimensi.length >= MAX_DIMENSI)
      return alert(`Maksimal ${MAX_DIMENSI} dimensi`);
    setPilihanDimensi((prev) => [
      ...prev,
      { DimensiProfile: item.dimensi, SubDimensi: item.sub },
    ]);
  };

  /* ================= UPDATE ================= */
  const handleUpdate = async () => {
    if (!idData) return alert("Cari data terlebih dahulu");
    if (judulKokulikuler.some((j) => !j.trim()))
      return alert("Judul tidak boleh kosong");
    if (pilihanDimensi.length === 0) return alert("Pilih minimal 1 dimensi");

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}api/kokulikuler/${idData}`,
        { judulKokulikuler, pilihanDimensi },
        { headers: { "Content-Type": "application/json" } },
      );
      alert("Data berhasil diperbarui");
    } catch {
      alert("Gagal update data");
    }
  };

  /* ================= JSX ================= */
  return (
    <div className="max-w-5xl mx-auto p-6 min-h-screen flex flex-col">
      <h1 className="text-xl font-bold mb-4">Edit Kokulikuler</h1>

      {/* FILTER */}
      <div className="grid grid-cols-4 gap-3 mb-4">
        <select
          name="kelas"
          value={filter.kelas}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        >
          <option value="">Kelas</option>
          {[1, 2, 3, 4, 5, 6].map((k) => (
            <option key={k} value={k}>
              {k}
            </option>
          ))}
        </select>

        <select
          name="rombel"
          value={filter.rombel}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        >
          <option value="">Rombel</option>
          {["A", "B", "C", "D"].map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>

        <input
          name="tahun"
          value={filter.tahun}
          onChange={handleFilterChange}
          placeholder="2024"
          className="border p-2 rounded"
        />
        <select
          name="semester"
          value={filter.semester}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        >
          <option value="">Semester</option>
          <option value="1">1</option>
          <option value="2">2</option>
        </select>
      </div>

      <button
        onClick={handleCariData}
        className="bg-indigo-600 text-white px-4 py-2 rounded"
      >
        Cari Data
      </button>
      {loading && <p className="mt-3">Loading...</p>}

      {/* FORM EDIT */}
      {idData && (
        <div className="mt-4 space-y-3">
          {/* Judul */}
          {judulKokulikuler.map((j, i) => (
            <div key={i} className="flex gap-2">
              <input
                value={j}
                onChange={(e) => handleJudulChange(i, e.target.value)}
                maxLength={70}
                placeholder={`Judul ${i + 1}`}
                className="border p-2 rounded w-full"
              />
              <button
                type="button"
                onClick={() => removeJudul(i)}
                className="bg-red-500 text-white px-3 rounded"
              >
                ✕
              </button>
            </div>
          ))}
          {judulKokulikuler.length < MAX_JUDUL && (
            <button
              type="button"
              onClick={addJudul}
              className="text-blue-600 text-sm"
            >
              + Tambah Judul
            </button>
          )}

          {/* Dimensi */}
          <p className="text-sm mb-2 text-gray-600">
            Dipilih: {pilihanDimensi.length} / {MAX_DIMENSI}
          </p>
          <table className="w-full border text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="border p-2">Pilih</th>
                <th className="border p-2">No</th>
                <th className="border p-2">Dimensi</th>
                <th className="border p-2">Sub Dimensi</th>
              </tr>
            </thead>
            <tbody>
              {MASTER_DIMENSI.map((item) => {
                const checked = pilihanDimensi.some(
                  (d) =>
                    d.DimensiProfile === item.dimensi &&
                    d.SubDimensi === item.sub,
                );
                return (
                  <tr key={item.no}>
                    <td className="border p-2 text-center">
                      <input
                        type="checkbox"
                        checked={checked}
                        disabled={
                          !checked && pilihanDimensi.length >= MAX_DIMENSI
                        }
                        onChange={() => toggleDimensi(item)}
                      />
                    </td>
                    <td className="border p-2">{item.no}</td>
                    <td className="border p-2">{item.dimensi}</td>
                    <td className="border p-2">{item.sub}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <button
            onClick={handleUpdate}
            className="mt-4 bg-green-600 text-white px-6 py-2 rounded"
          >
            Update Data
          </button>
        </div>
      )}
      <div className="flex justify-center mt-5">
        <Link to={`/Kokurikuler/${id}`}>
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default EditKokulikuler;
